import React from 'react';
import {useTranslation} from 'react-i18next';
import Button from '../../../../../incase-domain/components/button/Button';
import DropdownMenuCompact from '../../../../../incase-domain/components/dropdownMenuCompact/DropdownMenuCompact';
import Label from '../../../../../incase-domain/components/label/Label';
import {IElementQuestionMatchPair, MatchPairQuestionMode} from '../../../../../incase-domain/elements/question/questionMatchPair';

interface MatchPairModeSelectProps {
    highlightedElement: IElementQuestionMatchPair;
    highlightedElementChangeHandler: {
        single: (field: keyof IElementQuestionMatchPair | string, value: unknown) => void;
    };
}

export default function MatchPairModeSelect(props: MatchPairModeSelectProps): JSX.Element {
    const {highlightedElement, highlightedElementChangeHandler} = props;
    const {t} = useTranslation();

    const options = [
        {label: t('presEditPage.editSidebar.elements.matchPairQuestion.modeLines'), value: MatchPairQuestionMode.LINES},
        {label: t('presEditPage.editSidebar.elements.matchPairQuestion.modeCards'), value: MatchPairQuestionMode.CARDS},
    ];
    const selectedMode = highlightedElement.matchPairMode || MatchPairQuestionMode.LINES;

    return (
        <div className="l-group--form">
            <div className="l-group__item">
                <Label>{t('presEditPage.editSidebar.elements.matchPairQuestion.mode')}</Label>
                <DropdownMenuCompact
                    width="full"
                    className="c-sidepanel__dropdown"
                    items={[
                        options.map((option) => ({
                            label: option.label,
                            onClick: () => highlightedElementChangeHandler.single('matchPairMode', option.value),
                        })),
                    ]}
                >
                    <Button
                        variant="soft"
                        size="xs"
                        fullWidth
                        trailing="solar:alt-arrow-down-linear"
                        className="c-sidepanel__dropdown_button"
                    >
                        {options.find((option) => option.value === selectedMode)?.label}
                    </Button>
                </DropdownMenuCompact>
            </div>
        </div>
    );
}
